import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button';

const CTASection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="page" style={{ paddingTop: 80, paddingBottom: 40 }}>
      <div style={{ textAlign: 'center', maxWidth: 640, margin: '0 auto' }}>
        <h2 style={{ fontSize: 44, fontWeight: 600, letterSpacing: '-0.025em' }}>
          Start shipping in 60 seconds.
        </h2>
        <p className="muted" style={{ marginTop: 12, fontSize: 16 }}>
          No setup fees. No monthly minimums. Just better rates and less friction.
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 24 }}>
          <Button variant="primary" onClick={() => navigate('/signup')}>
            Open account
          </Button>
          <Button variant="secondary" onClick={() => navigate('/shipping')}>
            Get a quote
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
